// ABOUTME: Fiamm company-specific UI override definition.
// ABOUTME: Registers the Balance Goals page route and menu item for FIAMM_UI_BALANCE_GOAL users.

import { AssessmentIcon } from '@ds/coolshop';
import { lazy } from 'react';

import { CompanyOverride } from '../types';

const BalanceGoalsPage = lazy(() => import('@pages/BalanceGoalsPage'));

export const fiammOverride: CompanyOverride = {
    companyIds: ['fiamm'],
    menuItems: [
        {
            id: 'balance-goals',
            path: 'balance-goals',
            icon: <AssessmentIcon />,
            isActive: ctx => ctx.hasUserRole('FIAMM_UI_BALANCE_GOAL'),
            order: 0,
        },
    ],
    routes: [
        {
            path: 'balance-goals',
            component: BalanceGoalsPage,
            isActive: ctx => ctx.hasUserRole('FIAMM_UI_BALANCE_GOAL'),
        },
    ],
    getDefaultRoute: ctx => (ctx.hasUserRole('FIAMM_CLIENT') ? '/balance-goals' : null),
};
